import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import Container from "../../base/components/container.js";
import I18n from "../../base/i18n.js";

import MybilioTextLogoWhite from "../../resources/logo/mybilio_text_logo_white.js";

import IcFacebook from "../../resources/icons/socials/ic_facebook.js";
import IcTwitter from "../../resources/icons/socials/ic_twitter.js";
import IcInstagram from "../../resources/icons/socials/ic_instagram.js";
import IcYouTube from "../../resources/icons/socials/ic_you_tube.js";
import IcLinkedIn from "../../resources/icons/socials/ic_linked_in.js";

import { ProjectsAnchor } from "../pages/index/constants.js";

import Routes from "../routes.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.black,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 16px 100px",
    justifyContent: "space-between",
    ['@media (max-width: 768px)']: {
      padding: "48px 24px",
    },
  },
  row: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  logo: {
    display: "block",
    marginBottom: "40px",
    ['@media (max-width: 992px)']: {
      display: "none",
    },
  },
  link: {
    display: "block",
    fontSize: "18px",
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "29px",
    color: theme.palette.white,
    textDecoration: "none",
    '&:hover': {
      textDecoration: "underline",
    },
    margin: "0 16px 14px",

    ['@media (max-width: 768px)']: {
      textAlign: "center",
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  smallLink: {
    fontSize: "12px",
    lineHeight: "22px",
    margin: "0 7px"
  },
  linkGroup: {
    ['@media (max-width: 768px)']: {
      flexDirection: "column",
      alignItems: "center"
    },
  },
  accent: {
    color: theme.palette.greenMain,
    fontSize: "18px",
    marginBottom: "20px",
    ['@media (max-width: 768px)']: {
      fontSize: "16px",
    }
  },
  socialLinksContainer: {
    marginBottom: "14px",
    display: "flex",
  },
  socialLink: {
    marginRight: "16px",
    "&:last-child": {
      marginRight: "0px"
    }
  },
  copyright: {
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.white,
    fontSize: "12px",
    lineHeight: "22px",
    margin: "0 7px"
  },
}));

const PageFooter = () => {
  const classes = blockStyles();

  const firstRow = () => {
    return <div className = {  clsx(classes.row, classes.linkGroup) } >
      <Link to = { Routes.aboutUs() }
            className = { classes.link } >
        { I18n.t("shared.about_us") }
      </Link>
      <HashLink to = { Routes.index({anchor: ProjectsAnchor}) }
                className = { classes.link } >
        { I18n.t("shared.projects")}
      </HashLink>
      <Link to = { Routes.faq() }
            className = { classes.link } >
        { I18n.t("shared.faq") }
      </Link>
      <Link to = { Routes.press() }
            className = { classes.link } >
        { I18n.t("shared.press") }
      </Link>
      <Link to = { Routes.becomeAPartner() }
            className = { classes.link } >
        { I18n.t("shared.become_a_partner") }
      </Link>
      <Link to = { Routes.contacts() }
            className = { classes.link } >
        { I18n.t("shared.contacts") }
      </Link>
    </div>
  }

  const secondRow = () => {
    return <div className = { classes.row } >
      <span className = { classes.accent }>{ I18n.t("shared.follow_us") }</span>
    </div>
  }

  const thirdRow = () => {
    return <div className = { classes.row } >
      <div className = { classes.socialLinksContainer } >
        <a href = { Routes.facebook() }
          className = { classes.socialLink }
          rel = 'noreferrer'
          target = { "_blank" } >
          <IcFacebook />
        </a>
        <a href = { Routes.linkedIn() }
          className = { classes.socialLink }
          rel = 'noreferrer'
          target = { "_blank" } >
          <IcLinkedIn />
        </a>
        <a href = { Routes.instagram() }
          className = { classes.socialLink }
          rel = 'noreferrer'
          target = { "_blank" } >
          <IcInstagram />
        </a>
      </div>
    </div>
  }

  const fourthRow = () => {
    return <div className = { classes.row } >
      <div className = { classes.copyright } >
        { I18n.t("shared.copyright") }
      </div>
      <Link to = { Routes.termsAndConditions() }
            className = { clsx(classes.link, classes.smallLink) } >
        { I18n.t("shared.terms_and_conditions") }
      </Link>
      <Link to = { Routes.imprint() }
            className = { clsx(classes.link, classes.smallLink) } >
        { I18n.t("shared.imprint") }
      </Link>
      <Link to = { Routes.dataProtection() }
            className = { clsx(classes.link, classes.smallLink) } >
        { I18n.t("shared.data_protection") }
      </Link>
      <Link to = { Routes.mandatoryInformation() }
            className = { clsx(classes.link, classes.smallLink) } >
        { I18n.t("shared.mandatory_information") }
      </Link>
      <Link to = { Routes.riskWarning() }
            className = { clsx(classes.link, classes.smallLink) } >
        { I18n.t("shared.risk_warning") }
      </Link>
    </div>
  }

  return (
    <div className = { classes.root } >
      <Container className = { classes.content } >
        <div className = { clsx(classes.row, classes.logo) } >
          <MybilioTextLogoWhite />
        </div>
        { firstRow() }
        { secondRow() }
        { thirdRow() }
        { fourthRow() }
      </Container>
    </div>
  );
}

export default PageFooter;
